import { el, mount, unmount } from 'redom';
import SimpleDialogNative from 'generics/components/simple-dialog/native';
import ConfirmationPrompt from './confirmation';
import FullscreenBanner from './fullscreen-banner';

class Prompts {

  constructor() {

    this.promptsContainer = null;
    this.currentConfirmationPrompt = null;

  }

  initializePromptsContainer() {

    this.promptsContainer = el('div#prompts-container');
    mount(document.body, this.promptsContainer);

  }

  initialize() {

    this.initializePromptsContainer();

  }

  createConfirmPrompt(configuration) {

    function closeConfirmPrompt() {

      configuration.onCancel();

    }

    const confirmationPrompt = new ConfirmationPrompt({
      ...configuration,
      onClose: closeConfirmPrompt
    });

    const dialogOptions = {

      contentHolderClassName: 'new-confirm-prompt',
      content: confirmationPrompt,
      onClose() {
        closeConfirmPrompt();
      }

    };

    return new SimpleDialogNative(dialogOptions);

  }

  unmountCurrentConfirmationPrompt() {

    unmount(this.promptsContainer, this.currentConfirmationPrompt);

  }

  getConfirmCallback(resolveFunction) {

    return function confirmCallBack() {

      this.unmountCurrentConfirmationPrompt();
      resolveFunction(true);

    }.bind(this);

  }

  getCancelCallback(resolveFunction) {

    return function cancelCallback() {

      this.unmountCurrentConfirmationPrompt();
      resolveFunction(false);

    }.bind(this);

  }

  getConfirmationPromptResolver(configuration) {

    return function confirmationPromptResolver(resolveFunction) {

      const onConfirm = this.getConfirmCallback(resolveFunction);
      const onCancel = this.getCancelCallback(resolveFunction);

      this.currentConfirmationPrompt = this.createConfirmPrompt({
        ...configuration,
        onConfirm,
        onCancel
      });

      mount(this.promptsContainer, this.currentConfirmationPrompt);

    }.bind(this);
  }

  confirm(configuration) {

    const resolver = this.getConfirmationPromptResolver(configuration);
    return new Promise(resolver);

  }

  displayFullScreenBanner(message) {

    const banner = new FullscreenBanner({ prompts: this, message });

    return banner;

  }

}

export default Prompts;